import React, { useEffect, useState } from "react";
import {
  CUSTOM_SQUAD_TIME,
  SQUAD_TIME_OPTIONS,
  isListedSquadTime,
  normalizeSquadTime,
} from "../../utility/createSquad";

const selectClassName =
  "w-full p-2 border border-brand-charcoal/20 rounded-lg bg-white text-brand-charcoal focus:outline-none focus:ring-2 focus:ring-brand-gold-ink disabled:bg-brand-cream disabled:cursor-not-allowed";

const SquadTimeSelect = ({
  value,
  onChange,
  disabled = false,
  required = false,
  exclude = [],
  placeholder = "Select time",
  id,
}) => {
  const [useCustom, setUseCustom] = useState(
    Boolean(value) && !isListedSquadTime(value)
  );

  useEffect(() => {
    if (value && !isListedSquadTime(value)) setUseCustom(true);
  }, [value]);

  const selectValue = useCustom ? CUSTOM_SQUAD_TIME : value || "";

  return (
    <div className="space-y-2">
      <select
        id={id}
        value={selectValue}
        disabled={disabled}
        required={required && !useCustom}
        onChange={(event) => {
          const next = event.target.value;
          if (next === CUSTOM_SQUAD_TIME) {
            setUseCustom(true);
            if (isListedSquadTime(value)) onChange("");
            return;
          }
          setUseCustom(false);
          onChange(next);
        }}
        className={selectClassName}
      >
        <option value="">{placeholder}</option>
        {SQUAD_TIME_OPTIONS.filter(
          (option) => !exclude.includes(option.value)
        ).map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
        <option value={CUSTOM_SQUAD_TIME}>Custom</option>
      </select>
      {useCustom ? (
        <input
          type="time"
          value={normalizeSquadTime(value)}
          disabled={disabled}
          required={required}
          aria-label="Custom squad time"
          onChange={(event) => onChange(normalizeSquadTime(event.target.value))}
          className={selectClassName}
        />
      ) : null}
    </div>
  );
};

export default SquadTimeSelect;
